import { generalBillPaymentsConstants } from "../_constants";

export const payeeCategoriesListRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_REQUEST,
    payload,
  };
};

export const payeeCategoriesListComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_COMPLETE,
    payload,
  };
};

export const payeeCategoriesListError = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_ERROR,
    payload,
  };
};

export const payeeTypesListRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_TYPES_LIST_REQUEST,
    payload,
  };
};

export const payeeTypesListComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_TYPES_LIST_COMPLETE,
    payload,
  };
};

export const payeeTypesListError = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYEE_TYPES_LIST_ERROR,
    payload,
  };
};

export const payableListRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYABLE_LIST_REQUEST,
    payload,
  };
};

export const payableListComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYABLE_LIST_COMPLETE,
    payload,
  };
};

export const payableListError = (payload) => {
  return {
    type: generalBillPaymentsConstants.PAYABLE_LIST_ERROR,
    payload,
  };
};

export const setSelectedCategory = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_SLECETED_CATEGORY,
    payload,
  };
};

export const setSelectedPayeeType = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_SELECTED_PAYEE_TYPE,
    payload,
  };
};

export const setReloadBillerCategories = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_RELOAD_BILLER_CATEGORIES,
    payload,
  };
};

export const setPayableAcccounts = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_PAYABE_ACCOUNTS,
    payload,
  };
};

export const setPayableCards = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_PAYABE_CARDS,
    payload,
  };
};

export const setSelectedPaymentOption = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_SELECTED_PAYMENT_OPTION,
    payload,
  };
};

export const setPayAccountNumber = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_PAY_ACCOUNT_NUMBER,
    payload,
  };
};

export const setCardType = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_CARD_TYPE,
    payload,
  };
};

export const setPayBalance = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_PAY_BALANCE,
    payload,
  };
};

export const setPayeeType = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_PAYEE_TYPE,
    payload,
  };
};

export const setBillAccountNumber = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_BILL_ACCOUNT_NUMBER,
    payload,
  };
};

export const setBillAmount = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_BILL_AMOUNT,
    payload,
  };
};

export const setBillOutstandingAmount = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_BILL_OUTSTANDING_AMOUNT,
    payload,
  };
};

export const validateBillAccountNumberRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_REQUEST,
    payload,
  };
};

export const validateBillAccountNumberComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_COMPLETE,
    payload,
  };
};

export const validateBillAccountNumberError = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_ERROR,
    payload,
  };
};

export const validateBillAmountRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_REQUEST,
    payload,
  };
};

export const validateBillAmountomplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_COMPLETE,
    payload,
  };
};

export const validateBillAmountError = (payload) => {
  return {
    type: generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_ERROR,
    payload,
  };
};

export const setScreenType = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_BILLER_SCREEN_TYPE,
    payload,
  };
};

export const payBillRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.GENERAL_PAY_BILL_REQUEST,
    payload,
  };
};

export const payBillError = (payload) => {
  return {
    type: generalBillPaymentsConstants.GENERAL_PAY_BILL_ERROR,
    payload,
  };
};

export const payBillComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.GENERAL_PAY_BILL_COMPLETE,
    payload,
  };
};

export const otpConfirmationRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.OTP_CONFIRMATION_REQUEST,
    payload,
  };
};
export const otpConfirmationComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.OTP_CONFIRMATION_COMPLETE,
    payload,
  };
};
export const otpConfirmationError = (payload) => {
  return {
    type: generalBillPaymentsConstants.OTP_CONFIRMATION_ERROR,
    payload,
  };
};

export const clearGeneralBiller = () => {
  return {
    type: generalBillPaymentsConstants.CLEAR_GENAREL_BILLER,
  };
};

export const tryAgainBillPayment = () => {
  return {
    type: generalBillPaymentsConstants.TRY_AGAIN_BILL_PAYMENT,
  };
};

export const resendOtpRequest = (payload) => {
  return {
    type: generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_REQUEST,
    payload,
  };
};

export const resendOtpComplete = (payload) => {
  return {
    type: generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const resendOtpError = (payload) => {
  return {
    type: generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_ERROR,
    payload,
  };
};

export const setBillerTransactionInitiateData = (payload) => {
  return {
    type: generalBillPaymentsConstants.SET_BILLER_TRANSACTION_INITIATE_DATA,
    payload,
  };
};
